import {
  InputCheckbox,
  InputCheckboxGroup,
  InputTextField,
  DatePickerTextField
} from '@abbott-components/core';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import Stack from '@mui/material/Stack';
import ControlState from '../../Shared/controlState';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import formatName from '../formatName';
import SizingSelect from '../../Shared/SizingSelect';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const { schema } = control;

  const properties = schema?.properties as JSONSchema7Properties;

  const defaultMinDate = new Date('01/01/1000');

  const defaultMaxDate = new Date('12/31/3000');

  const minDate = new Date(properties['minimumDate'].default as string);

  const maxDate = new Date(properties['maximumDate'].default as string);

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 4 }}>
          <InputTextField
            name={formatName(properties['label']?.$id as string)}
            label="Date Entry Label"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 4 }}>
          <InputTextField
            name={formatName(properties['id']?.$id as string)}
            label="ID"
            isDisabled={isReadOnlyView}
          />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 4 }}>
          <DatePickerTextField
            name={formatName(properties['minimumDate']?.$id as string)}
            label="Minimum Date"
            defaultValue={minDate}
            minDate={defaultMinDate}
            maxDate={defaultMaxDate}
            disabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 4 }}>
          <DatePickerTextField
            name={formatName(properties['maximumDate']?.$id as string)}
            label="Maximum Date"
            defaultValue={maxDate}
            minDate={defaultMinDate}
            maxDate={defaultMaxDate}
            disabled={isReadOnlyView}
          />
        </Stack>
        <SizingSelect
          isReadOnlyView={isReadOnlyView}
          name={formatName(properties['gridSize']?.$id as string)}
        />
      </Stack>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 2 }}>
          <InputCheckboxGroup
            name={`${formatName(
              properties['required']?.$id as string
            )}-inputCheckBoxGroup`}
            isDisabled={isReadOnlyView}
          >
            <InputCheckbox
              name={formatName(properties['required']?.$id as string)}
              defaultChecked={
                (properties['required'].default as boolean) ?? false
              }
            >
              Required Field
            </InputCheckbox>
          </InputCheckboxGroup>
        </Stack>
      </Stack>
    </Stack>
  );
};
